export class InvestigationStatusSnapshotEntity {
  public id!: string;
  public sourceStatusId!: string;
  public name!: string;
  public displayName!: string;
  public color!: string;
  public categoryId!: number;
  public categoryName!: string;
  public sortOrder!: number;
  public isActive!: boolean;
}
